<template>
  <div class="register absolute" style="color: #000;">
    <div class="register_tit">
      <img @click="$router.go(-1)" src="../../../assets/images/licai/fanhui.png" />
      <p class="">{{ $t("m.yz_span0") }}</p>
    </div>
    <div class="register_block">
      <div
        style="border-radius:8px;background:#fff;padding:15px 10px;margin-top:8px; display:flex;align-items:center;min-height: 70px; justify-content: space-around;"
      >
        <div style="text-align:center;flex:1;">
          <p style="color:#000;">
            <span style="font-size:18px;font-weight:bold;">{{
              userInfo.usdt || 0
            }}</span>
          </p>
          <p style="font-size:12px;color:#666;margin-top:4px;">
            {{ $t("m.hz_span1") }}
          </p>
        </div>
        <div style="text-align:center;flex:1;">
          <p style="color:#000;">
            <span style="font-size:18px;font-weight:bold;">{{
              userInfo.money || 0
            }}</span>
          </p>
          <p style="font-size:12px;color:#666;margin-top:4px;">
            {{ $t("m.yz_span1") }}
          </p>
        </div>
        <div style="text-align:center;flex:1;">
          <p style="color:#000;">
            <span style="font-size:18px;font-weight:bold;">{{
              userInfo.gmo || 0
            }}</span>
          </p>
          <p style="font-size:12px;color:#666;margin-top:4px;">
            可用GMO
          </p>
        </div>
      </div>

      <div
        style="border-radius:8px;background:#fff;padding:15px 10px;margin-top:8px;padding-top:0;"
      >
        <div
          style="font-size:15px;padding-left:0;margin-top:10px;line-height:50px;display:flex;align-items:center;border-bottom:1px solid #eee;"
        >
          <div style="width:80px;">{{ $t("m.yz_span2") }}</div>
          <div style="width:50px;display:flex;align-items:center;">
            +<input
              style="width: 36px;"
              type="text"
              v-model="area"
            />
          </div>
          <input
            style="flex:1;font-size:15px;margin-left:8px;line-height:50px;"
            v-model="mobile"
            type="tel"
            :placeholder="$t('m.yz_span3')"
          />
        </div>

        <div
          style="font-size:15px;padding-left:0;margin-top:10px;line-height:50px;display:flex;align-items:center;border-bottom:1px solid #eee;"
        >
          <div style="width:80px;">{{ $t("m.yz_span4") }}</div>
          <div style="flex:1;">
            <input
              readonly
              style="font-size:15px;line-height:50px;width:100%;"
              :value="fieldText"
              @click="showField = true"
            />
          </div>
          <img
            @click="showField = true"
            src="../../../assets/images/new/xiangxia.png"
            style="width: 15px;height: 15px;"
            alt=""
          />
        </div>

        <div
          style="font-size:15px;padding-left:0;margin-top:10px;line-height:50px;display:flex;align-items:center;border-bottom:1px solid #eee;"
        >
          <div style="width:80px;">{{ $t("m.yz_span5") }}</div>
          <input
            type="number"
            style="flex:1;font-size:15px;line-height:50px;"
            v-model="amount"
            :placeholder="$t('m.yz_span6')"
          />
        </div>

        <div style="display:flex;margin-top:20px;align-items:flex-start;">
          <span style="color:#666;font-size:15px;width:80px;font-weight:bold;">{{
            $t("m.jf_span7")
          }}</span>
          <textarea
            v-model="remark"
            style="flex:1;border:1px solid #eee;border-radius:8px;height: 80px;padding:5px;"
            :placeholder="$t('m.yz_span7')"
          ></textarea>
        </div>
      </div>

      <div class="register_submit" @click="submit">
        {{ $t("m.yz_span8") }}
      </div>
      <div
        style="margin-top:12px;text-align:center;font-size:13px;color:var(--bg-color);"
        @click="$router.push({ path: '/yuezhuan_log' })"
      >
        {{ $t("m.yz_span9") }}
      </div>
    </div>

    <van-action-sheet
      v-model="showField"
      :actions="fieldActions"
      cancel-text="取消"
      close-on-click-action
      @select="onSelectField"
    ></van-action-sheet>

    <van-dialog
      confirmButtonColor="#4076FA"
      v-model="passwordShow"
      :title="$t('m.yh_span7')"
      show-cancel-button
      @confirm="doTransfer"
      @cancel="pwd = ''"
      @close="pwd = ''"
    >
      <div class="zfmm">
        <van-field
          v-model="pwd"
          :placeholder="$t('m.ct_span11')"
          type="password"
        />
      </div>
    </van-dialog>

    <div
      v-if="loading"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
    <div style="height: 70px;"></div>
  </div>
</template>

<script>
import Vue from "vue";
import { ActionSheet } from "vant";
Vue.use(ActionSheet);
import request from "@utils/request";
import { getMyUserInfo } from "@api/user";

export default {
  name: "YueZhuan",
  data() {
    return {
      area: 86,
      mobile: "",
      field: "money",
      amount: "",
      remark: "",
      pwd: "",
      showField: false,
      passwordShow: false,
      loading: false,
      userInfo: {}
    };
  },
  computed: {
    fieldActions() {
      return [
        { name: this.$t("m.yz_span10"), value: "money" },
        { name: this.$t("m.yz_span11"), value: "usdt" },
        { name: "GMO余额", value: "gmo" }
      ];
    },
    fieldText() {
      if (this.field === "usdt") {
        return this.$t("m.yz_span11");
      }
      if (this.field === "gmo") {
        return "GMO余额";
      }
      return this.$t("m.yz_span10");
    }
  },
  mounted() {
    getMyUserInfo()
      .then(res => {
        this.userInfo = res.data.data || {};
      })
      .catch(() => {});
  },
  methods: {
    onSelectField(item) {
      this.field = item.value;
      this.showField = false;
    },
    submit() {
      if (!this.mobile) {
        this.$dialog.message(this.$t("m.yz_span3"));
        return;
      }
      if (!this.amount || Number(this.amount) <= 0) {
        this.$dialog.message(this.$t("m.yz_span6"));
        return;
      }
      this.passwordShow = true;
    },
    doTransfer() {
      this.passwordShow = false;
      this.loading = true;
      request
        .post(
          "/pay/transfer/add",
          {
            area: this.area,
            mobile: this.mobile,
            amount: this.amount,
            field: this.field,
            pwd: this.pwd,
            remark: this.remark
          },
          { login: true }
        )
        .then(res => {
          this.loading = false;
          this.pwd = "";
          this.$dialog.success(res.data.msg || this.$t("m.yz_span12")).then(() => {
            this.amount = "";
            this.remark = "";
            getMyUserInfo().then(r => {
              this.userInfo = r.data.data || {};
            });
            this.$router.push({ path: "/yuezhuan_log" });
          });
        })
        .catch(err => {
          this.loading = false;
          this.pwd = "";
          const msg =
            (err.response && err.response.data && err.response.data.msg) ||
            "转账失败";
          this.$dialog.error(msg);
        });
    }
  }
};
</script>

<style scoped lang="less">
.register_tit {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
  background: #fff;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  font-size: 18px;
  color: #343434;
  line-height: 35px;
}
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 20px;
  text-align: center;
  line-height: 45px;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
}
.register_block {
  padding: 10px;
}
/deep/ .zfmm {
  padding: 10px 20px 20px;
  .van-field {
    background-color: #f1f1f3;
  }
}
</style>
